<template lang="pug"> 
  v-row(justify='start' align='start')
    v-col().mx-12       
      v-btn(small text :to='{name: "inicio"}' color='white') 
        h4.black--text Inicio
      v-icon(small color='rojo') fas fa-chevron-right
      v-btn(small text :to='{name:"productos" }' color='white') 
        h4.black--text Lineas comerciales
      v-icon(small color='rojo') fas fa-chevron-right 

      v-btn(v-if='linea_comercial' small text :to='{name:"productos", params: {linea_comercial} }' color='white') 
        h4.black--text {{linea_comercial}}
      v-icon(v-if='categoria' small color='rojo') fas fa-chevron-right
      v-btn(v-if='categoria' small text :to='{name:"productos", params: {linea_comercial, categoria } }' color='white') 
        h4.black--text {{categoria}}
      v-icon(v-if='producto' small color='rojo') fas fa-chevron-right
      v-btn(v-if='producto' small text :to='{name:"productos", params: {linea_comercial, categoria, producto} }' color='white') 
        h4.black--text {{producto}}
     


</template>
<script>
export default {  
  props:{
    Grupo: String,
    Producto: String,
  },
  computed: {
    linea_comercial(){
      return this.$route.params.linea_comercial
    },
    categoria(){
      return this.$route.params.categoria
    },
    producto(){
      return this.$route.params.producto
    }
  }
}
</script>